import ceInfoAPI from "../api/ceInfoAPI";

const state = {
  data: [],
  isFetching: false,
  hasFetchedData: false,
  errorStatus: null,
};

const actions = {
  async fetchData({commit}, {id}) {
    commit("updateIsFetching", true);

    try {
      const response = await ceInfoAPI.fetch(id);
      commit("updateData", response);
      commit("updateErrorStatus", null);
    } catch (error) {
      console.error('Failed to fetch notification:', error);
      commit("updateErrorStatus", error?.response?.status);
      throw  error;
    } finally {
      commit("updateIsFetching", false);
    }
  }
};

const mutations = {
  updateData(state, payload) {
    state.data = {
      ...payload.data.data,
    };
    state.hasFetchedData = true;
  },

  updateIsFetching(state, isFetching) {
    state.isFetching = isFetching;
  },
  updateErrorStatus(state, errorStatus) {
    state.errorStatus = errorStatus;
  },
};

const getters = {
  data(state) {
    return state.data;
  },

  isFetching(state) {
    return state.isFetching;
  },

  hasFetchedData(state) {
    return state.hasFetchedData;
  },
  errorStatus(state) {
    return state.errorStatus;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
